/* eslint-disable @typescript-eslint/no-unused-vars */
import { Collapse, Typography } from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning'
import WatchLaterIcon from '@material-ui/icons/WatchLater'
import React, { useEffect, useState } from 'react'

import { formatTime, parseServerInstant } from '../../../../helpers/date'
import { getTranslate, lang } from '../../../../localization'
import { useStyles } from './styles/index.styles'

interface ExpireTimeCounterProps {
  expiryTime: string
  setIsTimeExpired: React.Dispatch<React.SetStateAction<boolean>>
}

const ExpireTimeCounter: React.FC<ExpireTimeCounterProps> = ({
  expiryTime,
  setIsTimeExpired
}) => {
  const classes = useStyles()
  const [timeLeftInSeconds, setTimeLeftInSeconds] = useState(0)
  const [warning, setwarning] = useState(false)

  useEffect(() => {
    // new Date() on an unlabelled datetime parses it as LOCAL time, which inflated this
    // countdown by the viewer's offset from the zone the server rendered in.
    const target = parseServerInstant(expiryTime)
    const targetTime = target ? target.getTime() : NaN
    const updateTimer = () => {
      const now = Date.now()

      const diffInSeconds = Math.floor((targetTime - now) / 1000)
      setTimeLeftInSeconds(Math.max(0, diffInSeconds))

      if (diffInSeconds < 60 && diffInSeconds > 0) {
        setwarning(true)
      }
      if (diffInSeconds === 0) {
        setIsTimeExpired(true)
        setwarning(false)
      }
    }

    updateTimer()
    const interval = setInterval(updateTimer, 1000)
    return () => clearInterval(interval)
  }, [expiryTime])

  return (
    <div>
      <div className={classes.container}>
        <Typography variant="h5" className={classes.verticalAlign}>
          <WatchLaterIcon color="primary" className={classes.icon} />
          {getTranslate('Expire Time')}
        </Typography>
        <Typography
          variant="h5"
          className={classes.timeText}
          style={{ direction: lang == 'fa' ? 'ltr' : 'ltr' }}>
          {formatTime(timeLeftInSeconds)}
        </Typography>
      </div>
      <Collapse in={warning}>
        <div className={classes.warning}>
          <Typography
            variant="subtitle1"
            className={classes.verticalAlignWarning}>
            <WarningIcon className={classes.iconWarning} />
            {getTranslate('Finish this step earlier please')}
          </Typography>
          <Typography variant="h6" className={classes.warningText}>
            {getTranslate(
              'The Timer will run out in one minute, and once it ends, you will be taken back to step 1'
            )}
          </Typography>
        </div>
      </Collapse>
    </div>
  )
}

export default ExpireTimeCounter
